{
  "actions": "Radnje",
  "actionsAvailable": "Dostupne radnje.",
  "clearSelection": "Poništi odabir",
  "selected": "{count, plural, =0 {Nijedna nije odabrana} other {# je odabrano}}",
  "selectedAll": "Sve je odabrano"
}
